var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 15.7678L15.7525 17.1648L15.5834 13.1643L18.0716 10.0272L14.2147 8.9518L12.0001 5.61597L9.78542 8.9518L5.92849 10.0272L8.41669 13.1643L8.24763 17.1648L12.0001 15.7678ZM6.12221 20.0902L6.38704 13.8238L2.4895 8.90983L8.53102 7.22527L12.0001 2L15.4691 7.22527L21.5106 8.90983L17.6131 13.8238L17.8779 20.0902L12.0001 17.9019L6.12221 20.0902Z",
    fill: "currentColor"
  })));
};

export { SvgStar as ReactComponent };
export default __webpack_public_path__ + "5921188f937bef080490ab2c96c5a2d8.svg";